export enum MODAL_STATUS {
  INITIAL = 'INITIAL',
  SUBMITTING = 'SUBMITTING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}
